export const environment = {
    production: false,
    apiUrl: 'https://api-dev.fcastbid.com',
    app: 'https://app-dev.fcastbid.com',
    bff: 'https://portal-publico-dev.fcastbid.com'
};
